import React, { useState, useEffect, useRef } from "react";
import User from "../assets/User.png";
import { classNames } from "primereact/utils";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { FileUpload } from "primereact/fileupload";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Tag } from "primereact/tag";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { ProgressBar } from "primereact/progressbar";
import { Tooltip } from "primereact/tooltip";
import {
  addUser,
  uploadUsers,
  deleteUsers,
  deleteUser,
  inviteUser,
  inviteUsers,
} from "../apis/Users";
import utils from "../utils";
import { useSchoolStore } from "../store/SchoolStore";
import { useAuthStore } from "../store/AuthStore";
import { getGender, getRole, getState } from "../apis/Utilities";
import constants from "../constants";
import Layout from "../components/layout";
import UserList from "../components/User/UserList";

const Users = (props) => {

  const title = constants.modules.users;
  const [state,] = useAuthStore();
  const [{ schoolId },] = useSchoolStore();

  let emptyUser = {
    id: 0,
    schoolId: schoolId,
    lastName: null,
    firstName: null,
    gender: null,
    roles: null,
    staffId: null,
    address1: null,
    address2: null,
    state: null,
    email: null,
    phone: null,
    location: null,
    status: null,
    sendInvite: false,
    image: null,
    uploadFile: null,
    createdBy: state.username,
  };

  const fileUploadRef = useRef(null);
  const [totalSize, setTotalSize] = useState(0);
  const [genders, setGenders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [states, setStates] = useState([]);
  const [roles, setRoles] = useState([]);
  const [user, setUser] = useState(emptyUser);
  const [userDialog, setUserDialog] = useState(false);
  const [deleteUserDialog, setDeleteUserDialog] = useState(false);
  const [uploadUsersDialog, setUploadUsersDialog] = useState(false);
  const [deleteUsersDialog, setDeleteUsersDialog] = useState(false);
  const [invitedUsersDialog, setInvitedUsersDialog] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [usersChange, setUsersChange] = useState([]);
  const dt = useRef(null);
  const toastU = useRef(props.location.state.toast);

  const onTemplateSelect = (e) => {
    let _totalSize = totalSize;
    let files = e.files;

    Object.keys(files).forEach((key) => {
      _totalSize += files[key].size || 0;
    });

    setTotalSize(_totalSize);
  };

  const onTemplateUpload = (e) => {

    let _totalSize = 0;

    e.files.forEach((file) => {
      _totalSize += file.size || 0;
    });

    setTotalSize(_totalSize);

    toastU.current.show({
      severity: "info",
      summary: "Success",
      detail: "File Uploaded",
    });

  };

  const onTemplateRemove = (file, callback) => {
    setTotalSize(totalSize - file.size);
    callback();
  };

  const onTemplateClear = () => {
    setTotalSize(0);
  };

  const uploadHeaderTemplate = (options) => {
    const { className, chooseButton, uploadButton, cancelButton } = options;
    const value = totalSize / 10000;
    const formatedValue =
      fileUploadRef && fileUploadRef.current
        ? fileUploadRef.current.formatSize(totalSize)
        : "0 B";

    return (
      <div>
        <div
          className={className}
          style={{
            backgroundColor: "transparent",
            display: "flex",
            alignItems: "center",
          }}
        >
          {chooseButton}
          {uploadButton}
          {cancelButton}
        </div>

        <div className="formgrid grid">
          <div className="field col">
            <label htmlFor="roles" className="font-bold">
              Role(s)
            </label>
            <MultiSelect
              id="roles"
              value={user.roles}
              onChange={(e) => onInputChange(e, "roles")}
              options={roles}
              optionLabel="name"
              display="chip"
              placeholder="Select Roles"
              maxSelectedLabels={10}
              className="w-full md:w-22rem"
            />
          </div>

          <div className="field col">
            <label htmlFor="isVerified" className="font-bold">
              Send Invite
            </label>
            <Checkbox
              inputId="isVerified"
              onChange={(e) => onInputChange(e, "isVerified")}
              checked={user.isVerified}
              className="w-full md:w-10rem m-2"
            />
          </div>
          <div className="field col">
            <span>{formatedValue} / 1 MB</span>
            <ProgressBar
              value={value}
              showValue={false}
              style={{ width: "10rem", height: "12px" }}
            ></ProgressBar>
          </div>
        </div>
      </div>
    );
  };

  const uploadItemTemplate = (file, props) => {
    return (
      <div className="flex align-items-center flex-wrap">
        <div className="flex align-items-center" style={{ width: "40%" }}>
          <img
            alt={file.name}
            role="presentation"
            src={file.objectURL}
            width={100}
          />
          <span className="flex flex-column text-left ml-3">
            {file.name}
            <small>{new Date().toLocaleDateString()}</small>
          </span>
        </div>
        <Tag
          value={props.formatSize}
          severity="warning"
          className="px-3 py-2"
        />
        <Button
          type="button"
          icon="pi pi-times"
          className="p-button-outlined p-button-rounded p-button-danger ml-auto"
          onClick={() => onTemplateRemove(file, props.onRemove)}
        />
      </div>
    );
  };

  const emptyTemplate = () => {
    return (
      <div className="flex align-items-center flex-column">
        <i
          className="pi pi-image mt-3 p-5"
          style={{
            fontSize: "5em",
            borderRadius: "50%",
            backgroundColor: "var(--surface-b)",
            color: "var(--surface-d)",
          }}
        ></i>
        <span
          style={{ fontSize: "1.2em", color: "var(--text-color-secondary)" }}
          className="my-5"
        >
          Drag and Drop Image Here
        </span>
      </div>
    );
  };

  const chooseOptions = {
    icon: "pi pi-fw pi-file",
    iconOnly: true,
    className: "custom-choose-btn p-button-rounded p-button-outlined",
    tooltip: "Select file to upload",
  };

  const uploadOptions = {
    icon: "pi pi-fw pi-cloud-upload",
    iconOnly: true,
    className:
      "custom-upload-btn p-button-success p-button-rounded p-button-outlined",
    tooltip: "Click here to upload",
  };

  const cancelOptions = {
    icon: "pi pi-fw pi-times",
    iconOnly: true,
    className:
      "custom-cancel-btn p-button-danger p-button-rounded p-button-outlined",
    tooltip: "Click here to cancel",
  };

  useEffect(() => {
    async function fetchData() {
      const stateData = await getState();

      setStates(stateData.data);

      const genderData = await getGender();

      setGenders(genderData.data);

      const roleData = await getRole(schoolId);

      setRoles(roleData.data);
    }

    fetchData();
  }, []);

  const onIsVerifiedChange = (e) => {

    let _user = { ...user };

    _user["isVerified"] = e.value;

    setUser(_user);
  };

  const openNew = () => {
    setUser(emptyUser);
    setSubmitted(false);
    setUserDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setUserDialog(false);
  };

  const hideUploadDialog = () => {
    setSubmitted(false);
    setUploadUsersDialog(false);
  };

  const hideDeleteUserDialog = () => {
    setDeleteUserDialog(false);
  };

  const hideUploadUsersDialog = () => {
    setTotalSize(0);
    setUploadUsersDialog(false);
  };

  const hideDeleteUsersDialog = () => {
    setDeleteUsersDialog(false);
  };

  const hideInvitedUsersDialog = () => {
    setInvitedUsersDialog(false);
  };

  const saveUser = async () => {

    let toastData;

    setLoading(true);

    try {

      if (user) {

        if (user.id && user.id > 0) {

          const addUserRes = await editUser(user);

          if (
            addUserRes &&
            addUserRes.status === 200 &&
            addUserRes.data &&
            addUserRes.data.responseCode === "00"
          ) {
            toastData = utils.toastCallback({
              severity: "success",
              summary: addUserRes.ResponseCodeDescription,
              detail: "User edited successfully.",
            });
          } else {
            toastData = utils.toastCallback({
              severity: "error",
              summary: addUserRes.ResponseCodeDescription,
              detail: "User edited unsuccessfully.",
            });
          }
        } else {
          const addUserRes = await addUser(user);

          setLoading(false);

          if (
            addUserRes &&
            addUserRes.status === 200 &&
            addUserRes.data &&
            addUserRes.data.responseCode === "00"
          ) {
            toastData = utils.toastCallback({
              severity: "success",
              summary: addUserRes.ResponseCodeDescription,
              detail: "User added successfully.",
            });
          } else {
            toastData = utils.toastCallback({
              severity: "error",
              summary: addUserRes.ResponseCodeDescription,
              detail: "User added unsuccessful.",
            });
          }
        }
      }
    } catch (err) {

      setLoading(false);

      if (err.responseCodeDescription) {
        toastData = utils.toastCallback({
          severity: "error",
          summary: "User Error",
          detail: err.responseCodeDescription,
        });
      } else {
        toastData = utils.toastCallback({
          severity: "error",
          summary: "Network Error",
          detail: constants.networkErrorMessage,
        });
      }
    
    }

    setUserDialog(false);
    toastU.current.show(toastData);
    setUser(emptyUser);
    setSubmitted(true);
  };

  const uploadUser = async (e) => {

    let toastData;

    setLoading(true);

    try {

      if (
        user &&
        e &&
        e.files &&
        Array.isArray(e.files) &&
        e.files.length > 0
      ) {
        const uploadRes = await uploadUsers({
          file: e.files[0],
          schoolId: schoolId,
          role: JSON.stringify(user.roles),
          createBy: state.username,
        });

        setLoading(false);

        if (
          uploadRes &&
          uploadRes.status === 200 &&
          uploadRes.data &&
          uploadRes.data.responseCode === "00"
        ) {
          toastData = utils.toastCallback({
            severity: "success",
            summary: uploadRes.ResponseCodeDescription,
            detail: "Users uploaded successfully.",
          });
        } else {
          toastData = utils.toastCallback({
            severity: "error",
            summary: uploadRes.ResponseCodeDescription,
            detail: "Users upload unsuccessful.",
          });
        }
      }
    } catch (err) {

      setLoading(false);

      if (err.responseCodeDescription) {
        toastData = utils.toastCallback({
          severity: "error",
          summary: "Upload Error",
          detail: err.responseCodeDescription,
        });
      } else {
        toastData = utils.toastCallback({
          severity: "error",
          summary: "Network Error",
          detail: constants.networkErrorMessage,
        });
      }

    }

    hideUploadUsersDialog();

    toastU.current.show(toastData);
    setUser(emptyUser);
    setSubmitted(true);

  };

  const confirmDeleteUser = (product) => {
    setUser(product);
    setDeleteUserDialog(true);
  };

  const confirmUploadUser = (users) => {
    setUser(users);
    setUploadUsersDialog(true);
  };

  const deleteUserFunc = async () => {
    
    let toastData;

    setLoading(true);

    try {

      const res = await deleteUser(user.id);

      setLoading(false);

      if (
        res &&
        res.status === 200 &&
        res.data &&
        res.data.responseCode === "00"
      ) {
        toastData = utils.toastCallback({
          severity: "success",
          summary: res.ResponseCodeDescription,
          detail: "User deleted successfully.",
        });
      } else {
        toastData = utils.toastCallback({
          severity: "error",
          summary: res.ResponseCodeDescription,
          detail: "User deleted unsuccessful.",
        });
      }
    } catch (err) {

      setLoading(false);

      if (err.responseCodeDescription) {
        toastData = utils.toastCallback({
          severity: "error",
          summary: "Delete Error",
          detail: err.responseCodeDescription,
        });
      } else {
        toastData = utils.toastCallback({
          severity: "error",
          summary: "Network Error",
          detail: constants.networkErrorMessage,
        });
      }
    }

    setDeleteUserDialog(false);
    toastU.current.show(toastData);
    setUser(emptyUser);
    setSubmitted(true);

  };

  const inviteUser = async (id) => {

    let toastData;

    setLoading(true);

    setSubmitted(true);

    try {
      const res = await inviteUser(id);

      setLoading(false);

      if (
        res &&
        res.status === 200 &&
        res.data &&
        res.data.responseCode === "00"
      ) {
        toastData = utils.toastCallback({
          severity: "success",
          summary: res.ResponseCodeDescription,
          detail: "Invite successfully.",
        });
      } else {
        toastData = utils.toastCallback({
          severity: "error",
          summary: res.ResponseCodeDescription,
          detail: "Invite unsuccessful.",
        });
      }
    } catch (err) {
      setLoading(false);

      if (err.responseCodeDescription) {
        toastData = utils.toastCallback({
          severity: "error",
          summary: "Delete Error",
          detail: err.responseCodeDescription,
        });
      } else {
        toastData = utils.toastCallback({
          severity: "error",
          summary: "Network Error",
          detail: constants.networkErrorMessage,
        });
      }
    }

    setDeleteUserDialog(false);
    toastU.current.show(toastData);
    setUser(emptyUser);

  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const confirmDeleteSelected = () => {
    setDeleteUsersDialog(true);
  };

  const confirmInvitedSelected = () => {
    setInvitedUsersDialog(true);
  };

  const deleteSelectedUsers = async () => {

    let toastData;

    setLoading(true);

    try {

      const res = await deleteUsers(usersChange);

      setLoading(false);

      if (
        res &&
        res.status === 200 &&
        res.data &&
        res.data.responseCode === "00"
      ) {
        toastData = utils.toastCallback({
          severity: "success",
          summary: res.ResponseCodeDescription,
          detail: "Users Deleted.",
        });
      } else {
        toastData = utils.toastCallback({
          severity: "error",
          summary: res.ResponseCodeDescription,
          detail: "Users not Deleted.",
        });
      }
    } catch (err) {
      setLoading(false);

      if (err.responseCodeDescription) {
        toastData = utils.toastCallback({
          severity: "error",
          summary: "Delete Error",
          detail: err.responseCodeDescription,
        });
      } else {
        toastData = utils.toastCallback({
          severity: "error",
          summary: "Network Error",
          detail: constants.networkErrorMessage,
        });
      }
    }

    setDeleteUsersDialog(false);
    toastU.current.show(toastData);
    setUsersChange([]);
    setSubmitted(true);

  };

  const inviteSelectedUsers = async () => {

    let toastData;

    setLoading(true);

    try {

      console.log(usersChange);

      const res = await inviteUsers(usersChange);

      setLoading(false);

      if (
        res &&
        res.status === 200 &&
        res.data &&
        res.data.responseCode === "00"
      ) {
        toastData = utils.toastCallback({
          severity: "success",
          summary: res.ResponseCodeDescription,
          detail: "Users Invited.",
        });
      } else {
        toastData = utils.toastCallback({
          severity: "error",
          summary: res.ResponseCodeDescription,
          detail: "Users not Invited.",
        });
      }
    } catch (err) {
      setLoading(false);

      if (err.responseCodeDescription) {
        toastData = utils.toastCallback({
          severity: "error",
          summary: "Invite Error",
          detail: err.responseCodeDescription,
        });
      } else {
        toastData = utils.toastCallback({
          severity: "error",
          summary: "Network Error",
          detail: constants.networkErrorMessage,
        });
      }
    }

    setInvitedUsersDialog(false);
    toastU.current.show(toastData);
    setUsersChange([]);
    setSubmitted(true);

  };

  const onInputChange = (e, name) => {
    let val = (e.target && e.target.value) || '';
    if(e.target.checked) val = e.target.checked;
    let _user = { ...user };
    _user[`${name}`] = val;
    setUser(_user);
  };

  const leftToolbarTemplate = () => {
    return (
      <div className="flex flex-wrap gap-2">
        <Button
          label="New"
          icon="pi pi-plus"
          severity="success"
          onClick={openNew}
        />
        <Button
          label="Delete"
          icon="pi pi-trash"
          severity="danger"
          onClick={() => confirmDeleteSelected()}
          disabled={!usersChange || !usersChange.length}
        />
        <Button
          label="Send Invite"
          icon="pi pi-send"
          severity="secondary"
          onClick={() => confirmInvitedSelected()}
          disabled={!usersChange || !usersChange.length}
        />
      </div>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <Button
        label="Upload"
        icon="pi pi-upload"
        className="p-button-help"
        onClick={confirmUploadUser}
      />
    );
  };

  const editUser = (user) => {
    setUser({ ...user });
    setUserDialog(true);
  };

  const userDialogFooter = (
    <React.Fragment>
      <Button label="Cancel" icon="pi pi-times" outlined onClick={hideDialog} />
      <Button
        label="Save"
        icon={loading ? "pi pi-spin pi-spinner" : "pi pi-check"}
        onClick={async () => await saveUser()}
      />
    </React.Fragment>
  );

  const uploadUserDialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={hideUploadDialog}
      />
      <Button
        label="Upload"
        icon={loading ? "pi pi-spin pi-spinner" : "pi pi-check"}
        onClick={async () => {
          await uploadUser();
        }}
      />
    </React.Fragment>
  );

  const deleteUserDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteUserDialog}
      />
      <Button
        label="Yes"
        icon={loading ? "pi pi-spin pi-spinner" : "pi pi-check"}
        severity="danger"
        onClick={ async () => await deleteUserFunc() }
      />
    </React.Fragment>
  );

  const deleteUsersDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteUsersDialog}
      />
      <Button
        label="Yes"
        icon={loading ? "pi pi-spin pi-spinner" : "pi pi-check"}
        severity="danger"
        onClick={async () => await deleteSelectedUsers}
      />
    </React.Fragment>
  );

  const invitedUsersDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={invitedUsersDialog}
      />
      <Button
        label="Yes"
        icon={loading ? "pi pi-spin pi-spinner" : "pi pi-check"}
        severity="secondary"
        onClick={ async () => await inviteSelectedUsers }
      />
    </React.Fragment>
  );

  return (
    <Layout title={title} toast={toastU}>

      <Toast ref={toastU} />

      <div className="surface-0 text-700 m-3">
        <div className="card">

          <Toolbar
            className="mb-4"
            left={leftToolbarTemplate}
            right={rightToolbarTemplate}
          ></Toolbar>

          <UserList usersChange={usersChange} setUsersChange={setUsersChange} submitted={submitted} editUser={editUser} confirmDeleteUser={confirmDeleteUser} roleId={props.location.state.roleId} />

        </div>
      </div>

      <Dialog
        visible={userDialog}
        style={{ width: "32rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="User Details"
        modal
        className="p-fluid"
        footer={userDialogFooter}
        onHide={hideDialog}
      >

        {user.image && (
          <img
            src={user.image ? user.image : User}
            alt={user.image}
            className="product-image block m-auto pb-3"
          />
        )}

        <FileUpload
          className="mt-3 mb-3"
          mode="basic"
          name="demo[]"
          url="/api/upload"
          accept="image/*"
          maxFileSize={1000000}
        />

        <div className="formgrid grid">
          <div className="field col">
            <label htmlFor="firstName" className="font-bold">
              First Name
            </label>
            <InputText
              id="firstName"
              value={user.firstName}
              onChange={(e) => onInputChange(e, "firstName")}
              required
              autoFocus
              className={classNames({
                "p-invalid": submitted && !user.firstName,
              })}
            />
            {submitted && !user.firstName && (
              <small className="p-error">First Name is required.</small>
            )}
          </div>

          <div className="field col">
            <label htmlFor="lastName" className="font-bold">
              Last Name
            </label>
            <InputText
              id="lastName"
              value={user.lastName}
              onChange={(e) => onInputChange(e, "lastName")}
              required
              className={classNames({
                "p-invalid": submitted && !user.lastName,
              })}
            />
            {submitted && !user.lastName && (
              <small className="p-error">Last Name is required.</small>
            )}
          </div>
        </div>

        <div className="field">
          <label htmlFor="email" className="font-bold">
            Email
          </label>
          <InputText
            id="email"
            value={user.email}
            onChange={(e) => onInputChange(e, "email")}
            required
            className={classNames({ "p-invalid": submitted && !user.email })}
          />
          {submitted && !user.email && (
            <small className="p-error">Email is required.</small>
          )}
        </div>

        <div className="field">
          <label htmlFor="phone" className="font-bold">
            Phone
          </label>
          <InputText
            id="phone"
            value={user.phone}
            onChange={(e) => onInputChange(e, "phone")}
          />
        </div>

        <div className="field">
          <label htmlFor="address1" className="font-bold">
            Address1
          </label>
          <InputText
            id="address1"
            value={user.address1}
            onChange={(e) => onInputChange(e, "address1")}
          />
        </div>

        <div className="field">
          <label htmlFor="address2" className="font-bold">
            Address2
          </label>
          <InputText
            id="address2"
            value={user.address2}
            onChange={(e) => onInputChange(e, "address2")}
          />
        </div>

        <div className="field">
          <label htmlFor="state" className="font-bold">
            State
          </label>
          <Dropdown
            id="state"
            filter
            value={user.state}
            onChange={(e) => onInputChange(e, "state")}
            options={states}
            optionLabel="name"
            placeholder="Select a State"
          />
        </div>

        <div className="flex align-items-center mb-4 mt-4">
          <Checkbox
            inputId="sendInvite"
            onChange={(e) => onInputChange(e, "sendInvite")}
            checked={user.sendInvite}
          />
          <label htmlFor="sendInvite" className="font-bold ml-2">
            Send Invite
          </label>
        </div>

        <div className="formgrid grid">
          <div className="field col">
            <label htmlFor="roles" className="font-bold">
              Roles
            </label>
            <MultiSelect
              id="roles"
              value={user.roles}
              onChange={(e) => onInputChange(e, "roles")}
              options={roles}
              optionLabel="name"
              display="chip"
              placeholder="Select Roles"
              maxSelectedLabels={10}
            />
          </div>

          <div className="field col">
            <label htmlFor="gender" className="font-bold">
              Gender
            </label>
            <Dropdown
              id="gender"
              value={user.gender}
              onChange={(e) => onInputChange(e, "gender")}
              options={genders}
              optionLabel="name"
              placeholder="Select a Gender"
            />
          </div>
        </div>
      
      </Dialog>

      <Dialog
        visible={uploadUsersDialog}
        style={{ width: "50rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Upload Users"
        modal
        onHide={hideUploadUsersDialog}
      >
        <Tooltip
          target=".custom-choose-btn"
          content="Choose"
          position="bottom"
        />
        <Tooltip
          target=".custom-upload-btn"
          content="Upload"
          position="bottom"
        />
        <Tooltip
          target=".custom-cancel-btn"
          content="Clear"
          position="bottom"
        />

        <FileUpload
          ref={fileUploadRef}
          name="demo[]"
          accept=".xlsx, .csv, .xls"
          maxFileSize={1000000}
          uploadHandler={async (e) => await uploadUser(e)}
          customUpload={true}
          onUpload={onTemplateUpload}
          onSelect={onTemplateSelect}
          onError={onTemplateClear}
          onClear={onTemplateClear}
          headerTemplate={uploadHeaderTemplate}
          itemTemplate={uploadItemTemplate}
          emptyTemplate={emptyTemplate}
          chooseOptions={chooseOptions}
          uploadOptions={uploadOptions}
          cancelOptions={cancelOptions}
        />
      </Dialog>

      <Dialog
        visible={deleteUserDialog}
        style={{ width: "32rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={deleteUserDialogFooter}
        onHide={hideDeleteUserDialog}
      >
        <div className="confirmation-content">
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem" }}
          />
          {user && (
            <span>
              Are you sure you want to delete <b>{user.name}</b>?
            </span>
          )}
        </div>
      </Dialog>

      <Dialog
        visible={deleteUsersDialog}
        style={{ width: "32rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={deleteUsersDialogFooter}
        onHide={hideDeleteUsersDialog}
      >
        <div className="confirmation-content">
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem" }}
          />
          {usersChange && (
            <span>Are you sure you want to delete the selected Users?</span>
          )}
        </div>
      </Dialog>

      <Dialog
        visible={invitedUsersDialog}
        style={{ width: "32rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={invitedUsersDialogFooter}
        onHide={hideInvitedUsersDialog}
      >
        <div className="confirmation-content">
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem" }}
          />
          {usersChange && (
            <span>
              Are you sure you want to send invite to the selected Users?
            </span>
          )}
        </div>
      </Dialog>

    </Layout>
  );
};

export default Users;
